import { gql } from '@apollo/client';

export const getReferrerById = gql`
  query getReferrerById($id: Int!) {
    getReferrerById(id: $id) {
      id
      code
      customer_id
      url_views
      flow_starts
      customer_first_name
      customer_last_name
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

export const getReferrerByCustomerId = gql`
  query getReferrerByCustomerId($customer_id: Int!) {
    getReferrerByCustomerId(customer_id: $customer_id) {
      id
      code
      customer_id
      url_views
      flow_starts
      customer_first_name
      customer_last_name
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

export const createReferrer = gql`
  query CreateReferrer($customer_id: Int!) {
    createReferrer(customer_id: $customer_id) {
      id
      code
      customer_id
      url_views
      flow_starts
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

export const updateReferrerGql = gql`
  mutation updateReferrer($id: Int!, $data: ReferrerUpdateInput!) {
    updateReferrer(id: $id, data: $data) {
      code
      url_views
      flow_starts
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

export const createFinixIdentityGql = gql`
  mutation ensureFinixIdentity(
    $referrer_id: Int!
    $first_name: String!
    $last_name: String!
    $email: String!
    $phone_number: String!
    $address_line_1: String!
    $address_city: String!
    $address_state: String!
    $address_postal_code: String!
  ) {
    ensureFinixIdentity(
      referrer_id: $referrer_id
      first_name: $first_name
      last_name: $last_name
      email: $email
      phone_number: $phone_number
      address_line_1: $address_line_1
      address_city: $address_city
      address_state: $address_state
      address_postal_code: $address_postal_code
    )
  }
`;

export const createFinixPaymentInstrumentTokenGql = gql`
  mutation createFinixPaymentInstrumentTokenResolver($identity: String!, $token: String!) {
    createFinixPaymentInstrumentTokenResolver(identity: $identity, token: $token) {
      id
      pi_t
      pi_b
      pi_lf
      pi_em
      pi_ey
    }
  }
`;

export const verifyFinixPaymentInstrumentGql = gql`
  mutation verifyFinixPaymentInstrumentResolver($identity: String!, $instrument: String!) {
    verifyFinixPaymentInstrumentResolver(identity: $identity, instrument: $instrument) {
      id
    }
  }
`;

export const createFinixPaymentMerchantGql = gql`
  mutation createFinixPaymentMerchantResolver($identity: String!) {
    createFinixPaymentMerchantResolver(identity: $identity) {
      id
    }
  }
`;

export const disableFinixPaymentInstrumentGql = gql`
  mutation disableFinixPaymentInstrumentResolver($identity: String!, $instrument: String!) {
    disableFinixPaymentInstrumentResolver(identity: $identity, instrument: $instrument) {
      ok
    }
  }
`;

export const setCustomerIsTempPassword = gql`
  mutation externalCustomerSetTempPassword($customerId: Int!) {
    externalCustomerSetTempPassword(customerId: $customerId) {
      id
    }
  }
`;

export const getOwedAsRefereeGql = gql`
  query getOwedAsReferee($customer_id: Int!) {
    getOwedAsReferee(customer_id: $customer_id)
  }
`;

export const getReferrerAggregate = gql`
  query getReferrerAggregate($referrer_id: Int!) {
    getReferrerAggregate(referrer_id: $referrer_id) {
      total_referrals
      paid_referrals
      owed_referrals
      pending_referrals
    }
  }
`;
